<div class="progress-bar d-flex justify-content-center align-items-center" [ngClass]="{visible: visible}"> 
    <div class="progress-block">
        <h3 i18n *ngIf="isDownload">Téléchargement des fichiers en cours</h3>
        <h3 i18n *ngIf="!isDownload">Téléversement des fichiers en cours</h3>
        <h2 i18n>Fichier {{nameFile}} ({{currentFile}}/{{totalFiles}})</h2>
        <br/>
        <p-progressBar mode="determinate" [value]="progressValue" class="p-element"></p-progressBar>
    </div>
</div>
